export default {
  state: {
    projectDescription: '',
  },
  mutations: {
    createProjectDescription(state, projectDescription) {
      state.projectDescription = projectDescription;
    },
    updateProjectEditorDescription(state, description) {
      state.projectDescription = description;
    },
  },
};
